<template>
  <div class="editor-layout" ref="editorLayout" :class="{'horizontal-editor-layout': horizontalDisplay}">
    <div class="editor-layout__grid-wrapper" :class="{'horizontal-grid-wrapper': horizontalDisplay}" :style="maxWidth">
    <!-- Main -->
      <div class="editor-layout__main">
        <slot name="main"></slot>
      </div>
    <!-- Left -->
      <div class="editor-layout__left">
        <slot name="left" ></slot>
      </div>
    </div>
    <!-- Bottom fixed-->
    <div v-if="!isDraggableResizable && showBottom" class="editor-layout__bottom" ref="bottom" :class="{'horizontal-bottom': horizontalDisplay}" :style="maxWidth">
      <div class="editor-layout__drag-handle active">
        <i class="material-icons" >drag_indicator</i>
        <div class="editor-layout__drag-handle-right">
          <i class="material-icons" @click="undock">filter_none</i>
          <slot name="toggle"></slot>
        </div>
      </div>
      <slot name="bottom"></slot>
    </div>
    <!-- Bottom detached -->
    <vue-draggable-resizable v-else-if="showBottom"
          class-name="editor-layout__bottom-detached"
          :x="bottomBounds.x" 
          :y="bottomBounds.y" 
          :z="999" 
          :w="bottomBounds.w" 
          :h="bottomBounds.h" 
          :drag-handle="'.editor-layout__drag-handle'" 
          :enable-native-drag="true"
          :handles="['br']">
        <div class="editor-layout__drag-handle active">
        <i class="material-icons" >drag_indicator</i>
        <i class="material-icons" @click="dock">crop_din</i>
      </div>
      <slot name="bottom"></slot>
    </vue-draggable-resizable>
  </div>
</template>

<script>
import VueDraggableResizable from 'vue-draggable-resizable'
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'

export default {
  name: 'EditorLayout',

  components: {
    'vue-draggable-resizable': VueDraggableResizable,
  },

  props: {
    horizontalDisplay: {
      type: Boolean,
      default: false
    },
    showBottom: {
      type: Boolean,
      default: false
    }
  },

  data: function () {
    return {
      isDraggableResizable: false,
      bottomBounds: {
        x: 0,
        y: 0,
        w: 0,
        h: 0
      }
    }
  },

  computed: {
    maxWidth: function () {
      let maxWidth = window.screen.width - 80;
      return {
        maxWidth: maxWidth + 'px'
      } 
    }
  },

  mounted() {
    this.setBottomBounds()
  },

  methods: {
    setBottomBounds: function () {
      let bottomBounds = this.$refs.bottom ? this.$refs.bottom.getBoundingClientRect() : {}

      if (bottomBounds) {
        this.bottomBounds = {
          x: 0,
          y: 10,
          w: bottomBounds.width,
          h: bottomBounds.height
        }
      }
    },

    undock: function () {
      this.setBottomBounds()
      this.isDraggableResizable = true
    },

    dock: function () {
      this.isDraggableResizable = false
    },

    onResize: function (x, y, width, height) {
      this.bottomBounds.x = x
      this.bottomBounds.y = y
      this.bottomBounds.w = width
      this.bottomBounds.h = height
    },

    onDrag: function (x, y) {
      this.bottomBounds.x = x
      this.bottomBounds.y = y
    }
  }
}
</script>